import React from "react";

const ChangeBankDetails = {

    Title: "Change my bank account details",
    SubTitle:  "This is for the account we pay money into. If you need to change the account we collect payments from, please get in touch.",
 
    MobTitle:   
    (<React.Fragment>Change my bank account <center>details</center></React.Fragment>),
 
    SubTitleAlign:
    (<React.Fragment>This is for the account we pay money into. If you need to change the<center>account we collect payments from, please get in touch.</center></React.Fragment>),
 
    SubTitleForMob:
    (<React.Fragment>This is for the account we pay money into. If you need to change the account we collect payments<center>from, please get in touch.</center></React.Fragment>)
 
    
  };
  
  export default ChangeBankDetails;
  